import React, { useCallback } from 'react';
import { includes } from 'lodash';
import cn from 'classnames';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import type { ListNavTab } from 'types';
import { AVAILABLE_ROUTES_WITH_PARENT_ROUTE, isMobile } from 'app-constants';
import { extractParentRouteFromHistory, removeLastSlash } from 'utils';
import { NavButton } from 'components';
import { closeMobileTopMatches } from '../../actions';
import { selectIsMobileTopMatchesOpened } from '../../selectors';
import './ListNav.scss';

interface OwnProps {
    tabs: ListNavTab[];
}

type Props = OwnProps;

const ListNav: React.FC<Props> = ({ tabs }) => {
    useLocation();
    const dispatch = useDispatch();
    const isMobileTopMatchesOpened = useSelector(
        selectIsMobileTopMatchesOpened
    );

    const parentRoute = extractParentRouteFromHistory();

    const onClick = useCallback(() => {
        if (!isMobileTopMatchesOpened) return;

        dispatch(closeMobileTopMatches());
    }, [dispatch, isMobileTopMatchesOpened]);

    return (
        <div
            styleName={cn('container', {
                'is-mobile': isMobile,
            })}
        >
            {tabs.map(({ link, title, isDisable, isCreateButton = true }) =>
                isCreateButton ? (
                    <div
                        styleName="button"
                        className="__app-ListNav-button"
                        key={link}
                        onClick={onClick}
                    >
                        <NavButton
                            link={
                                includes(
                                    AVAILABLE_ROUTES_WITH_PARENT_ROUTE,
                                    link
                                )
                                    ? removeLastSlash(`${parentRoute}${link}`)
                                    : link
                            }
                            isDisable={!!isDisable}
                        >
                            {title}
                        </NavButton>
                    </div>
                ) : (
                    title
                )
            )}
        </div>
    );
};

export default ListNav;
